module.exports = __webpack_public_path__ + "static/media/forgotpwdicon.3e65c7e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/forgotpwdicon.png
// module id = 139
// module chunks = 0